import { render, staticRenderFns } from "./Myintegral.vue?vue&type=template&id=22169ca1&scoped=true"
import script from "./Myintegral.vue?vue&type=script&lang=js"
export * from "./Myintegral.vue?vue&type=script&lang=js"
import style0 from "./Myintegral.vue?vue&type=style&index=0&id=22169ca1&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22169ca1",
  null
  
)

export default component.exports